<template>
  <section class="ws-date-filter">
    <div class="ws-date-filter__dropdown">
      <b-dropdown
        aria-role="list"
        v-model="year"
        :disabled="disabled"
      >
        <button
          class="ws-button button is-text"
          slot="trigger"
          role="button"
        >
          <span v-text="$t('Год: ')"></span>
          <span
            id="date-filter-current-year"
            class="has-text-primary has-text-weight-bold"
            v-text="year"
          ></span>
          <ws-icon
            name="arrow-thin"
            :title="$t('Открыть меню')"
            color="#000"
            :fill="false"
            width="11"
            height="6"
          />
        </button>
        <b-dropdown-item
          v-for="y in years"
          :value="y"
          :key="y"
          aria-role="listitem"
        ><span v-text="y"></span></b-dropdown-item>
      </b-dropdown>
      <br>
      <b-checkbox v-model="isYearMode">{{ $t('Весь год') }}</b-checkbox>
    </div>
    <div class="ws-date-filter__months">
      <div
        class="ws-date-filter__months-item"
        v-for="(month, index) in defaultMonthNames"
        @click="selectMonth(index)"
        :class="{'is-active': currentMonthIndex === index, 'is-disabled': isMonthDisbled(index) || disabled || isYearMode}"
        :key="index"
      >
        <span
          class="ws-date-filter__months-title"
          v-text="month"
        ></span>
      </div>
    </div>
  </section>
</template>

<script>
import moment from 'moment'
function getYears (from) {
  let currentYear = new Date().getFullYear() + 1
  let arr = []
  while (from <= currentYear) {
    arr.push(currentYear--)
  }
  return arr
}
class DateObject {
  from
  to
  constructor (from = null, to = null) {
    this.from = from
    this.to = to
  }
}
export default {
  name: 'WsDateFilter',
  props: {
    date: {
      type: Object
    },
    disabled: {
      type: Boolean
    },
    yearMode: {
      type: Boolean
    }
  },
  data () {
    return {
      now: new Date(),
      newValue: new DateObject(),
      year: new Date().getFullYear(),
      // TODO get from api
      years: getYears(2019),
      currentMonthIndex: 0,
      // TODO refactor this
      defaultMonthNames: [
        'Январь',
        'Февраль',
        'Март',
        'Апрель',
        'Май',
        'Июнь',
        'Июль',
        'Август',
        'Сентябрь',
        'Октябрь',
        'Ноябрь',
        'Декабрь'
      ],
      isYearMode: this.yearMode || false
    }
  },
  watch: {
    date: {
      immediate: true,
      handler (value) {
        if (value && value.from && value.to) {
          const from = moment(new Date(value.from))
          const to = moment(new Date(value.to))
          this.isYearMode = from.month() !== to.month()
          this.currentMonthIndex = from.month()
          this.year = from.year()
        }
        this.newValue = value
      }
    },
    isYearMode (value) {
      if (!value) {
        this.currentMonthIndex = this.now.getMonth()
      }
      this.newValue = this.getSelectedDate()
      this.$nextTick(() => {
        this.$emit('change')
      })
    },
    newValue (value) {
      this.$emit('update:date', value)
    },
    year () {
      if (this.isMonthDisbled(this.currentMonthIndex)) {
        this.currentMonthIndex = this.now.getMonth()
      }
      this.newValue = this.getSelectedDate()
      this.$nextTick(() => {
        this.$emit('change')
      })
    }
  },
  methods: {
    getSelectedDate () {
      if (this.isYearMode) {
        return new DateObject(
          moment(new Date(this.year, 0, 1)).format('YYYY-MM-01'),
          moment(new Date(this.year, 11, 1)).endOf('month').format('YYYY-MM-DD')
        )
      } else {
        return new DateObject(
          moment(new Date(this.year, this.currentMonthIndex, 1)).format('YYYY-MM-01'),
          moment(new Date(this.year, this.currentMonthIndex, 1)).endOf('month').format('YYYY-MM-DD')
        )
      }
    },
    selectMonth (index) {
      if (this.isMonthDisbled(index) || index === this.currentMonthIndex || this.isYearMode) {
        return false
      }
      this.currentMonthIndex = index
      this.newValue = this.getSelectedDate()
      this.$nextTick(() => {
        this.$emit('change')
      })
    },
    isMonthDisbled (i) {
      // return (this.year === this.now.getFullYear() && i > this.now.getMonth()) || this.disabled
      return this.disabled
    }
  }
}
</script>
